import React, { useMemo } from 'react'
import MultipleCostInvoiceDiscountRow from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceDiscountRow'
// import useTranslation from 'next-translate/useTranslation'
// import GHref from 'tennders-market/common/components/element/GHref'

const MultipleCostInvoiceDiscountsTable = (props) => {
  const {
    discountLines,
    lines,
    discountErrors,
    onDiscountFormChange,
    removeDiscountLine,
    onNewAddDiscountLine,
    totalAmountOnInvoice,
    totalExtraCosts,
    defaultVat, companyId
  } = props
  // const { t } = useTranslation('multiple_cost_invoice')

  console.info('lines', discountLines)
  const renderDiscountLines = useMemo(() => {
    const dLines = discountLines.map((discount: Record<string, any>, index) => (
      <MultipleCostInvoiceDiscountRow
        initialErrors={discountErrors}
        key={discount.id}
        keyIndex={discount.id}
        index={index}
        companyId={companyId}
        defaultVat={defaultVat}
        onFormChange={onDiscountFormChange}
        costPrice={discount.applyTo === 'all' ? totalExtraCosts + totalAmountOnInvoice : totalAmountOnInvoice}
        removeLine={removeDiscountLine}
      />
    ))
    return dLines
  }, [totalAmountOnInvoice, totalExtraCosts, discountLines, discountErrors, defaultVat, onDiscountFormChange, removeDiscountLine, companyId])

  // const addButtonText = useMemo(() => (discountLines?.length > 0 ? t('add_discount') : t('add_another_discount')), [discountLines])

  return (
    <>
      <div className="hr"></div>
      <p className="text-uppercase mb-10 ls-1">
        <strong>Discounts</strong>
      </p>
      <table
        className="tennders-table-zebra "
        style={{ minWidth: 900 }}
      >
        <thead>
          <tr>
            <th />
            <th>#</th>
            <th colSpan={2}>Apply type</th>
            <th>Concept</th>
            <th>Percentage</th>
            <th>Amount</th>
            <th>Vat Percentage</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {renderDiscountLines}
        </tbody>
      </table>
      {/* <GHref className="btn-border small color-p mt-16" onClick={() => onNewAddDiscountLine()}>
        <span className=" mr-6">
          <i
            className="fa fa-plus"
            aria-hidden="true"
          />
        </span>
        {addButtonText}
      </GHref> */}
      <div className="hr"></div>
    </>
  )
}

export default React.memo(MultipleCostInvoiceDiscountsTable)
